
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150 150"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M118.67 57.15H31.33L44.94 138h59.91l13.82-80.85zM100.03 57.15V138M95.84 57.15V138M84.81 138v-23.96M84.81 82.63V57.15M80.62 138v-22.03M80.62 80.72V57.15M69.59 138v-22.09M69.59 80.77V57.15M65.4 138v-24.04M65.4 82.72V57.15M54.37 57.15V138M50.18 57.15V138"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"75.17","cy":"98.34","r":"18.43"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M75.05 83.46a15.18 15.18 0 0115.18 15.19M106.86 40.27a8.71 8.71 0 0110.94 8.41 8.51 8.51 0 01-8.7 8.47M89.08 30.43h.01M85.27 20.49a8.71 8.71 0 0116.47-.6M97.59 38.8a8.7 8.7 0 019.27 1.47"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M101.74 19.89c.42 0 .84-.07 1.27-.07a12.6 12.6 0 019.51 20.86M87.71 30.11a11.89 11.89 0 011.37.32 11.4 11.4 0 011.42.51 10.72 10.72 0 011.08.52 12.62 12.62 0 016 7.34M44.84 57.15c-6 0-10.87-4.43-10.87-10.43A10.87 10.87 0 0143.2 36M87.71 30.11q0-.33.06-.66t0-1a13.89 13.89 0 00-23.49-10M43.2 36a14.84 14.84 0 0121.11-17.56M62.8 43.6a7.74 7.74 0 01-1.53-4.6 7.83 7.83 0 0115.63-.72M76.9 38.23a7.85 7.85 0 014.17 6.93M48.91 48.56A7.84 7.84 0 0163 43.82"}})])
          )
        }
      }
    